<template lang='pug'>
  blue-layout( :user='user' :account='account' :biz='biz' )
    base-modal#hrs-modal( :show='popup.configure' )
      modal-wrapper.max( @close='close' )
        template( v-slot:header )
          h3 {{$t("Set Available Hours")}}
        template( v-slot:contents )
          set-hrs( ref='hrs' :cfg='cfg' )

    #upgrade( v-show='account.id' v-if='account.id && !account.merchant' )
      bf-notice(:message='message' @close='message = ""')

      transition(name='flip')
        bf-wrapper.max-960
          bf-divider.borderless.card
          h5.centered-text
            | {{ $t("Please fill up the information below to start selling or provide your service to your local neighbors.") }}
            
          bf-divider.borderless.card
          h5.centered-text(v-if="1==0")
            | {{ $t("We will review your application and get back to you within 24hours.") }}
          bf-divider.borderless.section
          form.business-profile.form( @submit.prevent='approve' )
            bf-flex.logo.centered( @click.native='$refs.upload.click()' )
              input( type='file' ref='upload' style='display: none' accept='image/*' @change='upload($event, "logo")' )
              template( v-if='doc.logo' )
                .image-container
                  img( :src='doc.logo' )
              template( v-else )
                bf-flex.upload-container.centered
                  img( src='/ui/no-image.png' )
                  span {{ $t('Add Your Logo') }}

            fieldset.upgrade
              h5 {{ $t("Business Name")}}/{{$t("Seller name")}}
              bf-input.name.labeled.basic
                input( type='text' v-model='doc.name' @input='pinyinify' required )

              .editable 
                h6 {{$t("Your dedicated URL")}}:
                p.red ({{$t("You will not be able to change it later")}})
                span.boldtext https://app.bluefaucet.com/m/
                input( ref='editable' v-model='doc.slug' :class='{ warn: !settable }' )
                span.warn( v-show='!settable' ) {{$t("Must be ascii")}}
                span.warn( v-show='!unique' ) {{$t("Must be unique")}}

              suglify.display( :slugify="doc.pinyinified" :slug.sync="doc.slug" :limit='128' )
                input( 
                  slot-scope="{inputBidding}" 
                  v-bind="inputBidding" 
                  type="text" 
                  class="form-control" 
                  :placeholder="$t('Display Name')"
                  disabled
                )
              
              set-hrs-widget( ref='widget' :initial='biz.cfg' @cfg='configure' )

              label {{ $t("Keyword")}} ({{$t("Press 'Enter' after each keyword")}})
              bf-input.basic.tags
                vue-tags-input.category.labeled.basic( v-model='tag' :tags='doc.tags' @tags-changed='tags => doc.tags = tags' )

              h5 {{ $t("Contact Information")}}

              label {{$t("Address")}}
              bf-input.address.labeled.basic
                input(type='text' v-model='doc.address')

              label {{$t("Phone")}}
              bf-input.address.labeled.basic
                input(type='phone' v-model='doc.phone')

              label {{$t("Email")}}
              bf-input.address.labeled.basic
                input(type='email' v-model='doc.email')

              label {{$t("Fax")}}
              bf-input.address.labeled.basic
                input(type='phone' v-model='doc.fax')

              label {{$t("Web Address")}}
              bf-input.address.labeled.basic
                input(type='url' v-model='doc.web')

              label {{$t("Yelp ID")}}
              bf-input.address.labeled.basic
                input(type='text' v-model='doc.yelp')

              label {{$t("Description")}}
              bf-input.address.labeled.basic.text-area
                textarea(v-model='doc.description')

              bf-divider.section.borderless
              bf-flex.centered.save-button-wrapper
                bf-button.combo.bright.tall.wide(type='submit')
                  template(v-slot:text) {{ $t('Upgrade Now!') }}
</template>

<script>
  import { db, str } from '@/main'
  import { View, Animatable } from '@/mixins/view'
  import SetHrs from '@/components/modals/set-hrs'
  import SetHrsWidget from '@/components/widgets/set-hrs'
  import BaseModal from '@/components/modals/base'
  import ModalWrapper from '@/components/modals/wrapper'
  import VueTagsInput from '@johmun/vue-tags-input'
  import Alphabetize, { getFullChars, getCamelChars } from 'chinese-alphabetize'

  export default {
    name: 'view.upgrade',

    components: {      
      BaseModal,
      ModalWrapper,
      SetHrs,
      SetHrsWidget,
      VueTagsInput
    },

    mixins: [ View, Animatable ],

    data() {
      return {
        doc: { hours: {}, name: '', pinyinified: '', slug: '', tags: [] },
        tag: '',
        message: '',
        collection: 'businesses',
        type: 'Business',
        password: {},
        step: 0,
        popup: { configure: false },
        cfg: { closures: [] },
        unique: true
      }
    },

    computed: {
      settable() {
        return /^[\x00-\x7F]*$/.test( this.doc.slug)
      }
    },

    watch: {
      account(curr, prev) {
        if ( curr.id && curr.merchant ) this.$router.go( -1 )
      }
    },

    methods: {
      validate() {
        if ( !this.settable ) this.$refs.editable.focus()
      },

      pinyinify( e ) {
        this.doc.pinyinified = Alphabetize.getFullChars( e.target.value ).replace( /([A-Z])/g, ' $1' ).replace( /undefined/g, '' )
        // console.log( this.doc.pinyinified )
      },

      configure( cfg ) {
        this.cfg = cfg
        this.popup.configure = true
      },

      close() {
        this.cfg.closures = this.$refs.hrs.closures
        this.popup.configure = false
      },

      async approve() {
        console.log('approving...');
        if ( !this.settable ) {
          this.$refs.editable.focus()
          return
        }

        let snap = await db.collection( 'businesses' ).doc( this.doc.slug ).get()
        console.log('snap', snap)
        let exists = snap.exists

        if ( exists ) {
          this.$refs.editable.focus()
          this.unique = false
          console.log('exists', exists );
          return
        }

        this.doc.user_id = this.user.uid
        this.cfg = this.$refs.widget.cfg
        db.collection( 'businesses' ).doc( this.doc.slug ).set({ ...this.doc, cfg: this.cfg })
        
        db.collection('accounts').doc( this.account.id ).update({
          merchant: 'basic',
          upgraded: { on: new Date(), bid: this.doc.slug }
        }).then( () => {
          this.user.updateProfile({ displayName: this.doc.slug }).then( () => {
            this.$router.push({ name: 'dashboard' })
          })
        })
      },

      upload( e, field ) {
        let reader  = new FileReader()
        reader.addEventListener('load', () => {
          const name = file.name
          let img = new Image()
          img.src = reader.result
          img.onload = () => {
            let width = img.width
            let height = img.height
            let ratio = img.width / img.height
            if( img.width > 100 ) {
              width = 100
              height = width / ratio
            }
            else if ( img.height > 100 ) {
              height = 100
              width = height * ratio
            }
            const elem = document.createElement('canvas')
            elem.width = width
            elem.height = height
            const ctx = elem.getContext('2d')
            ctx.drawImage( img, 0, 0, width, height )
            ctx.canvas.toBlob( blob => {
              const file = new File([blob], name, {
                type: 'image/jpeg',
                lastModified: Date.now()
              })

              let ref = str.ref( `/user/${this.user.uid}/logos/${file.name}` )
              ref.put(file).then( snap => {
                snap.ref.getDownloadURL().then( url => {
                  this.$set(this.doc, field, url)
                })
              }).catch( e => console.log(e) )
            }, 'image/jpeg', 1)
          }
          
        }, false)

          
        let file = e.target.files[0]
        if (file) reader.readAsDataURL(file)
      }
    },

    created() {
      if ( this.account.merchant ) this.$router.go(-1)
      
    }
  }
</script>

<style scoped lang='stylus'>
  h5 
    margin-top 10px
  .upgrade
    background white
    padding 15px
    border 1px solid lightgray
    border-radius 5px
  .editable
    .boldtext
      font-weight bold
      color blue
    .red
      color red
    padding 16px 0px
    input
      background rgb(245 245 245)
      width 250px
      @media(max-width: 560px)
        width 150px
      border 1px solid rgba( 0 0 0 .25 )
      border-radius 3px
      margin-right 8px
      padding 8px 5px
      &.warn
        border-color red
    span.warn
      color red

  .display
    width 100%
    padding 8px 24px
    color var(--clr-blue)
    display none
  table
    width 100%
    th
      width 102px

  .bf-input
    background rgb(245 245 245)
    margin-top 10px
    &.tags
      margin-top 10px
    >>> .vue-tags-input
      max-width 100%
  
  textarea
    height 64px

  table, th, tr, td
    border 1px solid black
    text-align left
    padding 10px
    margin 32px auto
  th
    font-weight bold
  tr
    margin-left 10px
    padding 5px
    &:nth-child(odd)
      background rgb( 220 220 220 )

  h4
    text-align justify

  #pending-container
    padding-top 16px

  #business-modal
    height calc( 100vh - var(--height-merchant-nav) )

  #highlight
    height var(--height-merchant-nav)
    position fixed
    bottom 0
    border 2px solid rgb( 240 160 80 )
    width 100vw
    box-sizing border-box

  #business-profile.view
    margin-top 24px
    .hours
      .closing
        margin-left 16px

  .bf-input
    >>> .vue-tags-input, >>> .ti-input
        border 0
        background 0

  .save-button-wrapper .bf-button
    margin 0 12px

  .logo
    margin 24px 0 16px 0
    .image-container
      width 88px
      height 88px
      img
        width 100%
        height 100%
        object-fit cover
        border-radius 50%
    .upload-container
      width 150px
      height 150px
      border 1px solid lightgray
      flex-direction column
      background rgb( 240 240 250 )
      border-radius 50%
      img
        width 30px
      span
        font-size .88em
        margin 8px 0
        font-weight bold

  #modal
    position fixed
    width 100vw
    height 100vh
    top 0
    left 0
    z-index 99
    background white
    color white
    align-items flex-start
    flex-direction column
    .close
      position absolute
      color white
      font-size 1.5em
      border 1px solid var(--clr-light)
      height 24px
      width 28px
      padding-bottom 4px
      display flex
      justify-content center
      border-radius 50%
      right 12px
      top 12px
    header
      position relative
      text-align center
      background var(--bg-nav)
      color white
      width 100%
      margin-bottom 96px
      padding 16px 0
      .heading
        color white
    main
      width 320px
      margin 0 auto
</style>
